import { create } from 'zustand'

import { getStoreItemsApi } from '@api'

import { createSelectors, Mapper } from './helpers'

export interface StoreItem {
  description: string
  description_ru?: string
  id: string
  image_url: string
  name: string
  prices: Record<string, number>
  supply?: number
  left_supply?: number
  type: string
}

export interface CreateItemOrder {
  invoice_url: {
    invoice_url: string
  }
  order: {
    address: string
    amount: number
    currency: string
    expires_at: string
    order_id: string
  }
}

export interface getStatusOrder {
  amount: number
  created_at: string
  currency: string
  expires_at: string
  id: string
  payment_charge_id: string
  status: string
  user_id: number
}

interface ShopState {
  isLoading: boolean
  isError: boolean
  items: StoreItem[] | null

  actions: {
    getStoreItems: () => void
  }
}

export const useShopStoreBase = create<ShopState>((set) => ({
  isLoading: true,
  isError: false,
  items: null,
  actions: {
    getStoreItems: async () => {
      set(() => ({ isLoading: true }))

      const { data, ok } = await getStoreItemsApi()

      if (ok && data) {
        set(() => ({
          items: data,
        }))
      }

      set(() => ({
        isLoading: false,
      }))
    },
  },
}))

export const useShopActions = () => useShopStoreBase((state) => state.actions)
export const useShopItems = () => useShopStoreBase((state) => state.items)
export const useBPItem = () =>
  useShopStoreBase((state) => {
    const bpItem = state.items?.filter((item) => item.type === 'battlepass')

    return bpItem?.length ? bpItem[0] : null
  })

export const useShop = createSelectors(useShopStoreBase)
